import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'

import { AppModule } from './app/app.module'
import { environment } from './app/environments/environment'

if (environment.production) {
  enableProdMode()
}

if (!firebase.apps.length) {
  firebase.initializeApp(environment.firebase)
}

const defaultApp = firebase.app()
if (typeof (defaultApp as any).database !== 'function' && typeof firebase.database === 'function') {
  const attachDatabase = (...args: unknown[]) => (firebase as any).database(...args)
  ;(defaultApp as any).database = attachDatabase
  const proto = (defaultApp as any).constructor?.prototype
  if (proto && typeof proto.database !== 'function') {
    proto.database = attachDatabase
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err))
